// extracted by mini-css-extract-plugin
export default {"btn":"SignInButton_btn__MNdvN","btnText":"SignInButton_btnText__c6pz6","btnIcon":"SignInButton_btnIcon__bek1p"};